import { Component, Shark, Utils } from "shark-mvc";
import { NousCore } from "nouscore-js-api";
import Tagify from "@yaireo/tagify";

import templateContent from "./custom-tags-card.html";
import customTagsCategoryManager from "../../controllers/customTagsCategoryManager";
import CustomTagsCategory from "../../models/CustomTagsCategory";
import contentCustomTagsManager from "../../controllers/contentCustomTagsManager";
import ContentCustomTags from "../../models/ContentCustomTags";

class CustomTagsComponent extends Component {
	constructor () {
		super("customTagsComponent");

		this.addTemplate("", templateContent);
	}

	afterLoad () {
		// const tagContainer = document.querySelector("#customTagsComponentTagsField");
		// new Tagify(tagContainer);
		// this.setupTagify();
	}

	beforeLoad () {
		const { customTagsCategoryList } = Shark.get();

		if (!customTagsCategoryList || customTagsCategoryList.length === 0) {
			customTagsCategoryManager.getList()
			.then(response => {
				const customTagsCategoryList = Shark.getInstanceList(CustomTagsCategory, response.data);

				Utils.reindexList(customTagsCategoryList);

				Shark.set({ customTagsCategoryList });
				this.matchCustomTagsAndCategory();
			});
		}

		let contentGuid = "";

		if (Shark.$store.currContent) {
			contentGuid = Shark.$store.currContent.guid;
		}
		else {
			const urlParams = new URLSearchParams(document.location.search);

			if (urlParams.has("coguid")) {
				contentGuid = urlParams.get("coguid");
			}
		}

		if (contentGuid !== "") {
			contentCustomTagsManager.getByContentGuid(contentGuid)
			.then(response => {
				console.log({response});
				Shark.set({
					currContentGuid: contentGuid,
					contentCustomTagsList: response.data,
				});
				
				this.matchCustomTagsAndCategory();
			});
		}
		else {
			Shark.set({
				currContentGuid: "",
				contentCustomTagsList: [],
			});
			this.matchCustomTagsAndCategory();
		}
	}

	init () {
		this.set({
			tagifyList: [],
		});

		Shark.set({
			contentCustomTagsList: Shark.$store.contentCustomTagsList || [],
		});
	}

	matchCustomTagsAndCategory () {
		const { contentCustomTagsList, customTagsCategoryList } = Shark.get();
		const sortedList = [];

		if (contentCustomTagsList && customTagsCategoryList && customTagsCategoryList.length > 0) {
			customTagsCategoryList.forEach(category => {
				const contentCustomTags = Utils.safp(contentCustomTagsList, "categoryGuid", category.guid);

				if (contentCustomTags) {
					sortedList.push(contentCustomTags);
				}
				else {
					sortedList.push(new ContentCustomTags({
						categoryGuid: category.guid,
						contentGuid: Shark.$store.currContentGuid,
						status: 1,
					}));
				}
			});

			Utils.reindexList(sortedList);

			console.log({sortedList, contentCustomTagsList, customTagsCategoryList});

			Shark.set({
				contentCustomTagsList: sortedList,
			});
			Shark.render(); //Dave: Qui sembra non rilevare il cambiamento del contenuto, ma perché?

			this.setupTagify();
		}
		else {
			console.log("SDKAPDSDADSçKDAçSLKDçLSAKAçSKDLSAKDçLASKDçASLKDçSAKDçLASKDçLSA");
			console.log("SDKAPDSDADSçKDAçSLKDçLSAKAçSKDLSAKDçLASKDçASLKDçSAKDçLASKDçLSA");
			console.log("SDKAPDSDADSçKDAçSLKDçLSAKAçSKDLSAKDçLASKDçASLKDçSAKDçLASKDçLSA");
		}

	}
	
	// retrieveCustomTags () {

	// }

	async save () {
		const { contentCustomTagsList } = Shark.get();

		if (contentCustomTagsList) {
			const contentCustomTagsManagerSaveMultiResult = await contentCustomTagsManager.saveMulti(contentCustomTagsList);
			console.log({contentCustomTagsManagerSaveMultiResult});
			return true;
		}

		return false;
	}

	setupTagify () {
		this.$store.tagifyList.forEach(item => {
			item.destroy();
		});
		
		this.$store.tagifyList = [];
		document.querySelectorAll(".customTagsField").forEach(item => {
			const newTagify = new Tagify(item, {autoComplete: { rightKey: true } });
			newTagify.on("input", this.onInput);
			newTagify.on("add", (event) => {
				console.log("tag addeddddd ", event);
				const value = event.detail.data.value;
				
				const tagParentToAdd = ["shopping", "intrattenimento", "vita notturna", "celebrità", "sport"].includes(value) ? "tempo libero" : ["arte", "storia", "architettura", "città", "musica", "cinema"].includes(value) ? "cultura" : ["paesaggi", "mare", "animali", "benessere", "cibo"].includes(value) ? "natura" : "";

				newTagify.addTags(tagParentToAdd);
			});
			this.$store.tagifyList.push(newTagify);
		});
	}

	onInput (event) {
		console.log(event);
		const value = event.detail.value;

		if (value.trim() !== "") {
			event.detail.tagify.whitelist = null; // reset the whitelist

			// https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort
			customTagsComponent.controller && customTagsComponent.controller.abort();
			customTagsComponent.controller = new AbortController();

			// show loading animation and hide the suggestions dropdown
			event.detail.tagify.loading(true).dropdown.hide();

			const rd = NousCore.api.createRequest({ item: { searchKey: value } });

			const request = {
				payload: rd,
				__nctoken__: localStorage["NousCore.api.last_token"],
				__ukey__: "",
			};

			let targetApiEndPoint = "";

			switch (Shark.activePage.id) {
				case "imageContentView":
					targetApiEndPoint = "image-content";
					break;
				case "placeContentView":
					targetApiEndPoint = "place-content";
					break;
				case "textContentView":
					targetApiEndPoint = "text-content";
					break;
			}

			// fetch(`https://wscontenutidigitali.lineacontinua.net/api/${targetApiEndPoint}/search-custom-tags`, {
			fetch(`${Shark.$store.apiURL}/${targetApiEndPoint}/search-custom-tags`, {
				body: JSON.stringify(request),
				method: "POST",
				signal: customTagsComponent.controller.signal,
			})
			.then(RES => RES.json())
			.then(function(data){
				const newWhitelist = new Set();
				data.payload.items.forEach(item => {
					JSON.parse(item.tags)?.forEach(tag => {
						newWhitelist.add(tag.value.toLowerCase());
					});
				});
				
				console.log({data, newWhitelist});

				event.detail.tagify.whitelist = Array.from(newWhitelist); // update whitelist Array in-place
				event.detail.tagify.loading(false).dropdown.show(value); // render the suggestions dropdown
			});
		}
	}
}

const customTagsComponent = new CustomTagsComponent();

Shark.registerComponent(customTagsComponent);

export default customTagsComponent;
